import yup from "src/validators/yup.Module";

export interface TributacaoCadastroDto {
  id: number;
  nome: string;
  naturezaOperacao: string;
  tipoOperacao: number;
  tipoOperacaoDescricao: string;
  padraoEmissaoCupomFiscal: boolean;
  padraoEmissaoCTe?: boolean;
}

export interface TributacaoCadastroCfopDto {
  id: number;
  tributacaoId: number;
  cfop: string;
  tipoParametro: number;
  tipoParametroDescricao: string;
  parametroValor: number;
  impostos: TributacaoCfopImpostoDto[];
}

export interface TributacaoCfopImpostoDto {
  id: number;
  tributacaoCFOPId: number;
  tipoImposto: number;
  tipoImpostoDescricao: string;
  cst: number;
  aliquotaSimples: string;
}

export const TributacaoCadastroSchema = yup.object().shape({
  nome: yup
    .string()
    .required("Campo é obrigatório")
    .min(3, "Deve conter entre 3 e 60 caracteres.")
    .max(60, "Deve conter entre 3 e 60 caracteres."),
  naturezaOperacao: yup
    .string()
    .required("Campo é obrigatório")
    .min(1, "Deve conter entre 1 e 60 caracteres.")
    .max(60, "Deve conter entre 1 e 60 caracteres."),
  tipoOperacao: yup
    .mixed()
    .test("is-valid-tipo-operacao", "Deve conter um valor válido.", (val) => {
      if (
        val === undefined ||
        val === null ||
        val === "" ||
        Number.isNaN(Number(val))
      ) {
        return false;
      }
      const num = Number(val);
      return num === 0 || num === 1;
    })
    .required("Deve conter um valor válido."),
  padraoEmissaoCupomFiscal: yup.boolean().notRequired(),
  padraoEmissaoCTe: yup.boolean().notRequired(),
});
